import axios from 'axios'

export default {
    indexReseller (resellerId) {
        return axios.get(`/api/resellers/${resellerId}/discounts`)
    },
}